module.exports = __webpack_public_path__ + "static/media/trash-btn.1bd40235.svg";